import Sidebar from "./sidebar/sidebar";
import { Navigate, Outlet } from "react-router-dom";
import { PermissionProvider } from "@/contexts/PermissionContext";

function Dashboard() {
  const userStateInfo = JSON.parse(
    localStorage.getItem("userStateInfo") || "{}"
  );
  const accessToken = localStorage.getItem("access_token");
  console.log("user state info:", userStateInfo);
  if (userStateInfo.identity_data_completion_needed === true) {
    return <Navigate to="/post-login" />;
  } else if (userStateInfo.package_selection_needed === true) {
    return <Navigate to="/post-login" />;
  } else if (userStateInfo.has_reserved === true) {
    return <Navigate to="/post-login" />;
  } else if (userStateInfo.has_payment_card === true) {
    return <Navigate to="/post-login" />;
  } else if (!accessToken) {
    return <Navigate to="/login" />;
  }
  return (
    <PermissionProvider>
      <div className="flex min-h-screen">
        <Sidebar />
        <main className="flex-1 bg-gray-100">
          <Outlet />
        </main>
      </div>
    </PermissionProvider>
  );
}

export default Dashboard;
